export const isRecoverableQuoteResponseMessage = (message?: string | null) => {
	if (!message) return false
	const normalized = String(message).toLowerCase()
	// Assurant may return this when the customer’s saved personal property amount is below the current allowed minimum.
	return normalized.includes('personal property') && normalized.includes('not within the allowed range')
}
